

<script context="module">import {
  computeMagnifierStyle,
  getCurrentComponent,
  isBrowser,
  isWebComponents,
  initMagnifier,
  parseClassName,
  parseZoom,
  styleToString
} from "./_utils.js";
import TwicMedia from "./TwicMedia.svelte";
import { onMount } from "svelte";
</script>
<script>export let alt = void 0;
export let anchor = void 0;
export let bot = void 0;
let className = void 0;
export { className as class };
export let focus = void 0;
export let intrinsic = void 0;
export let mode = void 0;
export let eager = false;
export let placeholder = void 0;
export let position = void 0;
export let preTransform = void 0;
export let ratio = void 0;
export let refit = void 0;
export let src;
export let step = void 0;
export let state = void 0;
export let title = void 0;
export let transition = void 0;
export let transitionDelay = void 0;
export let transitionDuration = void 0;
export let transitionTimingFunction = void 0;
export let zoom = void 0;
let hostElement;
$:
  parsedClassName = parseClassName(className) || ``;
$:
  parsedZoom = parseZoom(zoom);
$:
  props = {
    alt,
    anchor,
    bot,
    focus,
    intrinsic,
    mode,
    eager,
    placeholder,
    position,
    preTransform,
    ratio,
    refit,
    src,
    step,
    title,
    transition,
    transitionDelay,
    transitionDuration,
    transitionTimingFunction
  };
$:
  _magnifierStyle = styleToString(computeMagnifierStyle(parsedZoom));
$: {
  if (isWebComponents) {
    hostElement = getCurrentComponent();
    hostElement.className = `${parsedClassName} ${parsedZoom ? `twic-z` : ``} twic-d twic-i`;
    hostElement.style = _magnifierStyle;
  }
}
if (isBrowser) {
  onMount(() => {
    if (parsedZoom) {
      initMagnifier(hostElement);
    }
  });
}
</script>
{#if isWebComponents}
    {#if parsedZoom}
        <TwicMedia { ...props } class="twic-m" mediaTag="div" mode="cover"></TwicMedia>
    {/if}
    <TwicMedia { ...props } bind:state mediaTag="img" on:statechange></TwicMedia>
{:else}
<div
    bind:this={ hostElement }
    class = {`twic-i ${ parsedClassName } ${ parsedZoom ? `twic-z` : `` }`}
    style = { _magnifierStyle }
>
    {#if parsedZoom}
        <TwicMedia { ...props } class="twic-m" mediaTag="div" mode="cover"></TwicMedia>
    {/if}
    <TwicMedia { ...props } bind:state mediaTag="img" on:statechange></TwicMedia>
</div>
{/if}

